var _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 2.653 89.174 c -0.256 0 -0.512 -0.098 -0.707 -0.293 c -0.391 -0.391 -0.391 -1.023 0 -1.414 l 40.243 -40.243 c 0.391 -0.391 1.023 -0.391 1.414 0 s 0.391 1.023 0 1.414 L 3.36 88.881 C 3.164 89.076 2.908 89.174 2.653 89.174 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 79.421 42.886 c -0.42 0 -0.83 0.04 -1.234 0.098 c -0.471 -2.513 -2.028 -4.641 -4.165 -5.88 c -2.078 2.778 -4.36 5.624 -6.854 8.539 l 0.246 9.709 h 10.621 h 9.12 c 0.573 -1.155 0.903 -2.452 0.903 -3.828 C 88.058 46.753 84.191 42.886 79.421 42.886 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 23.801 25.879 c 1.726 -1.726 4.122 -2.689 6.557 -2.619 l 15.765 0.4 c 2.773 -2.373 5.481 -4.546 8.131 -6.543 c -2.083 -3.049 -5.585 -5.052 -9.557 -5.052 c -0.563 0 -1.111 0.054 -1.653 0.132 C 42.041 6.83 37.34 2.767 31.683 2.767 c -5.657 0 -10.358 4.063 -11.362 9.428 c -0.541 -0.078 -1.09 -0.132 -1.653 -0.132 c -6.389 0 -11.568 5.179 -11.568 11.568 c 0 1.844 0.443 3.581 1.21 5.128 h 12.611 L 23.801 25.879 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 66.501 30.498 c -1.764 0 -3.423 -0.687 -4.67 -1.935 c -1.248 -1.248 -1.936 -2.906 -1.936 -4.67 c 0 -1.765 0.688 -3.423 1.936 -4.671 c 1.247 -1.248 2.906 -1.935 4.67 -1.935 c 1.765 0 3.424 0.687 4.671 1.935 c 1.248 1.248 1.935 2.906 1.935 4.671 c 0 1.764 -0.687 3.423 -1.935 4.67 l 0 0 C 69.925 29.811 68.265 30.498 66.501 30.498 z M 66.501 19.287 c -1.229 0 -2.386 0.479 -3.256 1.349 c -0.87 0.87 -1.35 2.026 -1.35 3.257 c 0 1.23 0.479 2.386 1.35 3.256 c 0.87 0.87 2.026 1.349 3.256 1.349 c 1.23 0 2.387 -0.479 3.257 -1.349 l 0 0 c 0.87 -0.87 1.349 -2.026 1.349 -3.256 c 0 -1.23 -0.479 -2.387 -1.349 -3.257 C 68.887 19.766 67.731 19.287 66.501 19.287 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 89.987 4.147 c 0.084 -0.903 -0.235 -1.789 -0.877 -2.431 c -0.642 -0.642 -1.534 -0.961 -2.431 -0.877 C 75.05 1.928 61.171 9.362 45.271 22.986 L 29.41 22.584 c -2.377 -0.071 -4.688 0.867 -6.362 2.541 l -7.246 7.246 c -0.804 0.804 -1.11 1.941 -0.817 3.04 c 0.293 1.099 1.123 1.933 2.221 2.231 l 11.27 3.056 l 7.056 7.055 c 0.391 0.391 1.023 0.391 1.414 0 s 0.391 -1.023 0 -1.414 l -6.547 -6.547 C 52.91 16.665 71.904 4.232 86.866 2.831 c 0.309 -0.024 0.611 0.081 0.83 0.3 s 0.328 0.522 0.299 0.83 c -1.4 14.961 -13.835 33.956 -36.961 56.467 l -6.548 -6.548 c -0.391 -0.391 -1.023 -0.391 -1.414 0 s -0.391 1.023 0 1.414 l 7.057 7.056 l 3.056 11.269 c 0.297 1.099 1.132 1.929 2.231 2.222 c 0.274 0.073 0.551 0.109 0.825 0.109 c 0.82 -0.001 1.611 -0.323 2.214 -0.927 l 7.245 -7.245 c 1.676 -1.676 2.603 -3.994 2.542 -6.362 L 67.84 45.555 C 81.463 29.655 88.897 15.776 89.987 4.147 z M 28.69 38.684 l -10.96 -2.972 c -0.579 -0.157 -0.76 -0.623 -0.812 -0.815 c -0.051 -0.193 -0.125 -0.688 0.299 -1.111 l 7.246 -7.246 c 1.29 -1.289 3.08 -2 4.897 -1.956 l 13.674 0.346 C 38.417 29.005 33.633 33.593 28.69 38.684 z M 66.242 61.467 c 0.047 1.822 -0.666 3.607 -1.956 4.897 l -7.245 7.245 c -0.424 0.424 -0.917 0.35 -1.11 0.299 c -0.193 -0.052 -0.659 -0.233 -0.816 -0.813 l -2.972 -10.959 c 5.09 -4.943 9.679 -9.726 13.754 -14.343 L 66.242 61.467 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 25.031 78.36 c -0.256 0 -0.512 -0.098 -0.707 -0.293 c -0.391 -0.391 -0.391 -1.023 0 -1.414 L 40.67 60.306 c 0.391 -0.391 1.023 -0.391 1.414 0 s 0.391 1.023 0 1.414 L 25.738 78.067 C 25.542 78.262 25.286 78.36 25.031 78.36 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.92 70.356 c -0.256 0 -0.512 -0.098 -0.707 -0.293 c -0.391 -0.391 -0.391 -1.023 0 -1.414 l 19.811 -19.811 c 0.391 -0.391 1.023 -0.391 1.414 0 s 0.391 1.023 0 1.414 L 9.627 70.063 C 9.431 70.259 9.176 70.356 8.92 70.356 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 35.868 79.835 c -0.256 0 -0.512 -0.098 -0.707 -0.293 c -0.391 -0.391 -0.391 -1.023 0 -1.414 l 8.834 -8.835 c 0.391 -0.391 1.023 -0.391 1.414 0 s 0.391 1.023 0 1.414 l -8.834 8.835 C 36.38 79.737 36.124 79.835 35.868 79.835 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 13.346 53.618 c -0.256 0 -0.512 -0.098 -0.707 -0.293 c -0.391 -0.391 -0.391 -1.023 0 -1.414 l 7.224 -7.223 c 0.391 -0.391 1.023 -0.391 1.414 0 s 0.391 1.023 0 1.415 l -7.224 7.223 C 13.858 53.52 13.602 53.618 13.346 53.618 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 19.829 85.689 c -0.552 0 -1 -0.447 -1 -1 v -4.256 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 4.256 C 20.829 85.242 20.382 85.689 19.829 85.689 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 21.957 83.561 h -4.255 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 4.255 c 0.552 0 1 0.447 1 1 S 22.509 83.561 21.957 83.561 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 8.137 60.955 c -0.552 0 -1 -0.447 -1 -1 v -4.256 c 0 -0.553 0.448 -1 1 -1 s 1 0.447 1 1 v 4.256 C 9.137 60.508 8.69 60.955 8.137 60.955 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 10.265 58.827 H 6.01 c -0.552 0 -1 -0.447 -1 -1 s 0.448 -1 1 -1 h 4.255 c 0.552 0 1 0.447 1 1 S 10.817 58.827 10.265 58.827 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 3.194 78.277 c -0.853 0 -1.655 -0.333 -2.259 -0.937 C 0.332 76.738 0 75.935 0 75.083 s 0.332 -1.655 0.935 -2.259 c 1.246 -1.244 3.272 -1.244 4.517 0 c 0.604 0.604 0.936 1.406 0.936 2.259 s -0.332 1.654 -0.935 2.258 l 0 0 C 4.849 77.944 4.047 78.277 3.194 78.277 z M 3.194 73.889 c -0.306 0 -0.611 0.116 -0.844 0.349 C 2.124 74.464 2 74.763 2 75.083 c 0 0.318 0.124 0.618 0.35 0.844 c 0.451 0.451 1.238 0.451 1.688 0 h 0 c 0.226 -0.226 0.35 -0.525 0.35 -0.844 c 0 -0.319 -0.124 -0.619 -0.35 -0.845 C 3.805 74.006 3.499 73.889 3.194 73.889 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 30.658 87.236 c -0.818 0 -1.636 -0.312 -2.258 -0.934 c -0.604 -0.603 -0.936 -1.405 -0.936 -2.259 c 0 -0.853 0.332 -1.655 0.936 -2.258 c 1.245 -1.244 3.271 -1.244 4.517 0 c 0.604 0.603 0.936 1.405 0.936 2.258 c 0 0.854 -0.332 1.656 -0.936 2.259 C 32.294 86.925 31.476 87.236 30.658 87.236 z M 30.658 82.851 c -0.306 0 -0.611 0.116 -0.844 0.349 c -0.226 0.226 -0.35 0.525 -0.35 0.844 c 0 0.319 0.124 0.619 0.35 0.845 c 0.466 0.465 1.223 0.465 1.688 0 c 0.226 -0.226 0.35 -0.525 0.35 -0.845 c 0 -0.318 -0.124 -0.618 -0.35 -0.844 C 31.27 82.968 30.964 82.851 30.658 82.851 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(102,204,154)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.7ad9b9004efbadc09887c95b679954e9.svg";
export { ForwardRef as ReactComponent };